import r from "./icons/line/arrow-chevron-down.svg.js";
import e from "./icons/line/arrow-chevron-left.svg.js";
import o from "./icons/line/arrow-chevron-right.svg.js";
import i from "./icons/line/arrow-chevron-up.svg.js";
import a from "./icons/line/arrow-down.svg.js";
import n from "./icons/line/arrow-left.svg.js";
import t from "./icons/line/arrow-right.svg.js";
import m from "./icons/line/arrow-up.svg.js";
import l from "./icons/line/basic-shape-diamond.svg.js";
import d from "./icons/line/basic-shape-hexagon.svg.js";
import p from "./icons/line/basic-shape-primary-circle-ellipse-round.svg.js";
import c from "./icons/line/basic-shape-primary-square-rectangle.svg.js";
import f from "./icons/line/basic-shape-shield.svg.js";
import g from "./icons/line/computer-device-desktop-monitor.svg.js";
import s from "./icons/line/computer-device-desktop.svg.js";
import u from "./icons/line/computer-device-laptop.svg.js";
import b from "./icons/line/computer-device-mobile-phone-android-samsung-back.svg.js";
import h from "./icons/line/computer-device-mobile-phone-android-samsung.svg.js";
import S from "./icons/line/computer-device-mobile-phone-iphone-x-back.svg.js";
import B from "./icons/line/computer-device-mobile-phone-iphone-x.svg.js";
import w from "./icons/line/computer-device-mobile-tablet-touch.svg.js";
import L from "./icons/line/computer-device-mobile-tablet.svg.js";
import v from "./icons/line/computer-device-network-ethernet-cat6.svg.js";
import C from "./icons/line/computer-device-network-lan-www.svg.js";
import k from "./icons/line/computer-device-network-wifi-connection.svg.js";
import I from "./icons/line/computer-device-network-wifi-router.svg.js";
import y from "./icons/line/computer-keyboard-alt.svg.js";
import P from "./icons/line/computer-keyboard-command-cmd-control-ctrl.svg.js";
import D from "./icons/line/computer-keyboard-option.svg.js";
import E from "./icons/line/computer-keyboard-shift.svg.js";
import M from "./icons/line/ecology-science-erlenmeyer-flask.svg.js";
import A from "./icons/line/entertainment-control-button-circle-left-arrow-rewind.svg.js";
import x from "./icons/line/entertainment-control-button-circle-pause.svg.js";
import T from "./icons/line/entertainment-control-button-circle-right-arrow-fast-forward.svg.js";
import F from "./icons/line/entertainment-control-button-circle-stop-square.svg.js";
import q from "./icons/line/entertainment-control-button-play-circle.svg.js";
import R from "./icons/line/entertainment-party-popper-confetti.svg.js";
import G from "./icons/line/image-flash-lightning.svg.js";
import H from "./icons/line/image-photo-frame.svg.js";
import O from "./icons/line/image-picture-flower.svg.js";
import W from "./icons/line/interface-add.svg.js";
import N from "./icons/line/interface-alert-error-exclamation-block-square.svg.js";
import j from "./icons/line/interface-alert-error-x-block-square.svg.js";
import K from "./icons/line/interface-alert-exclamation-diamond.svg.js";
import V from "./icons/line/interface-alert-exclamation-triangle-warning.svg.js";
import U from "./icons/line/interface-alert-information-circle.svg.js";
import z from "./icons/line/interface-award-crown.svg.js";
import J from "./icons/line/interface-bookmark-tag.svg.js";
import X from "./icons/line/interface-bookmark.svg.js";
import Q from "./icons/line/interface-calendar-date-one.svg.js";
import Y from "./icons/line/interface-close.svg.js";
import Z from "./icons/line/interface-content-book-open-pages.svg.js";
import _ from "./icons/line/interface-content-book-page.svg.js";
import $ from "./icons/line/interface-content-file.svg.js";
import rr from "./icons/line/interface-content-folder.svg.js";
import er from "./icons/line/interface-copy-clipboard.svg.js";
import or from "./icons/line/interface-delete-bin-trash.svg.js";
import ir from "./icons/line/interface-dots-horizontal.svg.js";
import ar from "./icons/line/interface-dots-vertical.svg.js";
import nr from "./icons/line/interface-edit-attachment.svg.js";
import tr from "./icons/line/interface-edit-binocular.svg.js";
import mr from "./icons/line/interface-edit-magic-wand.svg.js";
import lr from "./icons/line/interface-edit-tool-eraser.svg.js";
import dr from "./icons/line/interface-edit-tool-paint-brush.svg.js";
import pr from "./icons/line/interface-edit-tool-paint-roller.svg.js";
import cr from "./icons/line/interface-edit-tool-pen.svg.js";
import fr from "./icons/line/interface-edit-tool-pencil.svg.js";
import gr from "./icons/line/interface-edit-view-eye.svg.js";
import sr from "./icons/line/interface-favorite-award.svg.js";
import ur from "./icons/line/interface-favorite-flag.svg.js";
import br from "./icons/line/interface-favorite-heart.svg.js";
import hr from "./icons/line/interface-favorite-star.svg.js";
import Sr from "./icons/line/interface-favorite-stars-shining.svg.js";
import Br from "./icons/line/interface-favorite-stars-sparkles.svg.js";
import wr from "./icons/line/interface-hierarchy-flowchart.svg.js";
import Lr from "./icons/line/interface-home-house.svg.js";
import vr from "./icons/line/interface-hyperlink.svg.js";
import Cr from "./icons/line/interface-lighting-brightness.svg.js";
import kr from "./icons/line/interface-lock-closed.svg.js";
import Ir from "./icons/line/interface-lock-open-unlock.svg.js";
import yr from "./icons/line/interface-login-key.svg.js";
import Pr from "./icons/line/interface-search.svg.js";
import Dr from "./icons/line/interface-setting-cog.svg.js";
import Er from "./icons/line/interface-share-megaphone-bullhorn.svg.js";
import Mr from "./icons/line/interface-share-rocket.svg.js";
import Ar from "./icons/line/interface-share-satellite.svg.js";
import xr from "./icons/line/interface-share-space-ship.svg.js";
import Tr from "./icons/line/interface-share.svg.js";
import Fr from "./icons/line/interface-signal-square.svg.js";
import qr from "./icons/line/interface-text-formatting-left-open-quote.svg.js";
import Rr from "./icons/line/interface-text-formatting-right-close-quote.svg.js";
import Gr from "./icons/line/interface-time-clock-circle.svg.js";
import Hr from "./icons/line/interface-time-hour-glass.svg.js";
import Or from "./icons/line/interface-users-multiple.svg.js";
import Wr from "./icons/line/interface-validation-checkbox-square.svg.js";
import Nr from "./icons/line/interface-weather-moon.svg.js";
import jr from "./icons/line/legal-justice-hammer-gavel.svg.js";
import Kr from "./icons/line/mail-chat-bubble-square.svg.js";
import Vr from "./icons/line/mail-send-email-paper-airplane.svg.js";
import Ur from "./icons/line/mail-send-envelope.svg.js";
import zr from "./icons/line/mail-sign-hashtag.svg.js";
import Jr from "./icons/line/money-cashier-receipt.svg.js";
import Xr from "./icons/line/money-currency-dollar-pay.svg.js";
import Qr from "./icons/line/money-graph-arrow-increase.svg.js";
import Yr from "./icons/line/money-graph-bar-chart-increase.svg.js";
import Zr from "./icons/line/nature-ecology-leaf.svg.js";
import _r from "./icons/line/phone-telephone.svg.js";
import $r from "./icons/line/programming-bug.svg.js";
import re from "./icons/line/programming-cloud.svg.js";
import ee from "./icons/line/programming-computer-database-server.svg.js";
import oe from "./icons/line/programming-computer-database.svg.js";
import ie from "./icons/line/programming-module-four-layout.svg.js";
import ae from "./icons/line/programming-module-three.svg.js";
import ne from "./icons/line/programming-module.svg.js";
import te from "./icons/line/programming-script-code.svg.js";
import me from "./icons/line/shopping-cart.svg.js";
import le from "./icons/line/shopping-gift-present.svg.js";
import de from "./icons/line/shopping-shipping-box-parcel-package.svg.js";
import pe from "./icons/line/tag-new-circle.svg.js";
import ce from "./icons/line/travel-map-earth-globe.svg.js";
import fe from "./icons/solid/arrow-chevron-down.svg.js";
import ge from "./icons/solid/arrow-chevron-left.svg.js";
import se from "./icons/solid/arrow-chevron-right.svg.js";
import ue from "./icons/solid/arrow-chevron-up.svg.js";
import be from "./icons/solid/arrow-down.svg.js";
import he from "./icons/solid/arrow-left.svg.js";
import Se from "./icons/solid/arrow-right.svg.js";
import Be from "./icons/solid/arrow-up.svg.js";
import we from "./icons/solid/basic-shape-diamond.svg.js";
import Le from "./icons/solid/basic-shape-hexagon.svg.js";
import ve from "./icons/solid/basic-shape-primary-circle-ellipse-round.svg.js";
import Ce from "./icons/solid/basic-shape-primary-square-rectangle.svg.js";
import ke from "./icons/solid/basic-shape-shield.svg.js";
import Ie from "./icons/solid/computer-device-desktop-monitor.svg.js";
import ye from "./icons/solid/computer-device-desktop.svg.js";
import Pe from "./icons/solid/computer-device-laptop.svg.js";
import De from "./icons/solid/computer-device-mobile-phone-android-samsung-back.svg.js";
import Ee from "./icons/solid/computer-device-mobile-phone-android-samsung.svg.js";
import Me from "./icons/solid/computer-device-mobile-phone-iphone-x-back.svg.js";
import Ae from "./icons/solid/computer-device-mobile-phone-iphone-x.svg.js";
import xe from "./icons/solid/computer-device-mobile-tablet-touch.svg.js";
import Te from "./icons/solid/computer-device-mobile-tablet.svg.js";
import Fe from "./icons/solid/computer-device-network-ethernet-cat6.svg.js";
import qe from "./icons/solid/computer-device-network-lan-www.svg.js";
import Re from "./icons/solid/computer-device-network-wifi-connection.svg.js";
import Ge from "./icons/solid/computer-device-network-wifi-router.svg.js";
import He from "./icons/solid/computer-keyboard-alt.svg.js";
import Oe from "./icons/solid/computer-keyboard-command-cmd-control-ctrl.svg.js";
import We from "./icons/solid/computer-keyboard-option.svg.js";
import Ne from "./icons/solid/computer-keyboard-shift.svg.js";
import je from "./icons/solid/ecology-science-erlenmeyer-flask.svg.js";
import Ke from "./icons/solid/entertainment-control-button-circle-left-arrow-rewind.svg.js";
import Ve from "./icons/solid/entertainment-control-button-circle-pause.svg.js";
import Ue from "./icons/solid/entertainment-control-button-circle-play.svg.js";
import ze from "./icons/solid/entertainment-control-button-circle-right-arrow-fast-forward.svg.js";
import Je from "./icons/solid/entertainment-control-button-circle-stop-square.svg.js";
import Xe from "./icons/solid/entertainment-party-popper-confetti.svg.js";
import Qe from "./icons/solid/image-flash-lightning.svg.js";
import Ye from "./icons/solid/image-photo-frame.svg.js";
import Ze from "./icons/solid/image-picture-flower.svg.js";
import _e from "./icons/solid/interface-add-square.svg.js";
import $e from "./icons/solid/interface-alert-error-exclamation-block-square.svg.js";
import ro from "./icons/solid/interface-alert-error-x-block-square.svg.js";
import eo from "./icons/solid/interface-alert-exclamation-diamond.svg.js";
import oo from "./icons/solid/interface-alert-exclamation-triangle-warning.svg.js";
import io from "./icons/solid/interface-alert-information-circle.svg.js";
import ao from "./icons/solid/interface-award-crown.svg.js";
import no from "./icons/solid/interface-bookmark-tag.svg.js";
import to from "./icons/solid/interface-bookmark.svg.js";
import mo from "./icons/solid/interface-calendar-date-one.svg.js";
import lo from "./icons/solid/interface-close.svg.js";
import po from "./icons/solid/interface-content-book-open-pages.svg.js";
import co from "./icons/solid/interface-content-book-page.svg.js";
import fo from "./icons/solid/interface-content-file.svg.js";
import go from "./icons/solid/interface-content-folder.svg.js";
import so from "./icons/solid/interface-copy-clipboard.svg.js";
import uo from "./icons/solid/interface-delete-bin-trash.svg.js";
import bo from "./icons/solid/interface-dots-horizontal.svg.js";
import ho from "./icons/solid/interface-dots-vertical.svg.js";
import So from "./icons/solid/interface-edit-attachment.svg.js";
import Bo from "./icons/solid/interface-edit-binocular.svg.js";
import wo from "./icons/solid/interface-edit-magic-wand.svg.js";
import Lo from "./icons/solid/interface-edit-tool-eraser.svg.js";
import vo from "./icons/solid/interface-edit-tool-paint-brush.svg.js";
import Co from "./icons/solid/interface-edit-tool-paint-roller.svg.js";
import ko from "./icons/solid/interface-edit-tool-pen.svg.js";
import Io from "./icons/solid/interface-edit-tool-pencil.svg.js";
import yo from "./icons/solid/interface-edit-view-eye.svg.js";
import Po from "./icons/solid/interface-favorite-award.svg.js";
import Do from "./icons/solid/interface-favorite-flag.svg.js";
import Eo from "./icons/solid/interface-favorite-heart.svg.js";
import Mo from "./icons/solid/interface-favorite-star.svg.js";
import Ao from "./icons/solid/interface-favorite-stars-shining.svg.js";
import xo from "./icons/solid/interface-favorite-stars-sparkles.svg.js";
import To from "./icons/solid/interface-hierarchy-flowchart.svg.js";
import Fo from "./icons/solid/interface-home-house.svg.js";
import qo from "./icons/solid/interface-hyperlink.svg.js";
import Ro from "./icons/solid/interface-lighting-brightness.svg.js";
import Go from "./icons/solid/interface-lock-closed.svg.js";
import Ho from "./icons/solid/interface-lock-open-unlock.svg.js";
import Oo from "./icons/solid/interface-login-key.svg.js";
import Wo from "./icons/solid/interface-search.svg.js";
import No from "./icons/solid/interface-setting-cog.svg.js";
import jo from "./icons/solid/interface-share-megaphone-bullhorn.svg.js";
import Ko from "./icons/solid/interface-share-rocket.svg.js";
import Vo from "./icons/solid/interface-share-satellite.svg.js";
import Uo from "./icons/solid/interface-share-space-ship.svg.js";
import zo from "./icons/solid/interface-share.svg.js";
import Jo from "./icons/solid/interface-signal-square.svg.js";
import Xo from "./icons/solid/interface-text-formatting-left-open-quote.svg.js";
import Qo from "./icons/solid/interface-text-formatting-right-close-quote.svg.js";
import Yo from "./icons/solid/interface-time-clock-circle.svg.js";
import Zo from "./icons/solid/interface-time-hour-glass.svg.js";
import _o from "./icons/solid/interface-users-multiple.svg.js";
import $o from "./icons/solid/interface-validation-checkbox-square.svg.js";
import ri from "./icons/solid/interface-weather-moon.svg.js";
import ei from "./icons/solid/legal-justice-hammer-gavel.svg.js";
import oi from "./icons/solid/mail-chat-bubble-square.svg.js";
import ii from "./icons/solid/mail-send-email-paper-airplane.svg.js";
import ai from "./icons/solid/mail-send-envelope.svg.js";
import ni from "./icons/solid/mail-sign-hashtag.svg.js";
import ti from "./icons/solid/money-cashier-receipt.svg.js";
import mi from "./icons/solid/money-currency-dollar-pay.svg.js";
import li from "./icons/solid/money-graph-arrow-increase.svg.js";
import di from "./icons/solid/money-graph-bar-chart-increase.svg.js";
import pi from "./icons/solid/nature-ecology-leaf.svg.js";
import ci from "./icons/solid/phone-telephone.svg.js";
import fi from "./icons/solid/programming-bug.svg.js";
import gi from "./icons/solid/programming-cloud.svg.js";
import si from "./icons/solid/programming-computer-database-server.svg.js";
import ui from "./icons/solid/programming-computer-database.svg.js";
import bi from "./icons/solid/programming-module-four-layout.svg.js";
import hi from "./icons/solid/programming-module-three.svg.js";
import Si from "./icons/solid/programming-module.svg.js";
import Bi from "./icons/solid/programming-script-code.svg.js";
import wi from "./icons/solid/shopping-cart.svg.js";
import Li from "./icons/solid/shopping-gift-present.svg.js";
import vi from "./icons/solid/shopping-shipping-box-parcel-package.svg.js";
import Ci from "./icons/solid/tag-new-circle.svg.js";
import ki from "./icons/solid/travel-map-earth-globe.svg.js";
import Ii from "./icons/brand/brand-adobe.svg.js";
import yi from "./icons/brand/brand-amazon.svg.js";
import Pi from "./icons/brand/brand-browser-firefox.svg.js";
import Di from "./icons/brand/brand-browser-googlechrome.svg.js";
import Ei from "./icons/brand/brand-creative-commons.svg.js";
import Mi from "./icons/brand/brand-ecommerce-etsy.svg.js";
import Ai from "./icons/brand/brand-ecommerce-patreon.svg.js";
import xi from "./icons/brand/brand-ecommerce-shopify.svg.js";
import Ti from "./icons/brand/brand-ecommerce-wordpress.svg.js";
import Fi from "./icons/brand/brand-gaming-nintendo-switch.svg.js";
import qi from "./icons/brand/brand-gaming-playstation.svg.js";
import Ri from "./icons/brand/brand-gaming-xbox-live.svg.js";
import Gi from "./icons/brand/brand-google-drive.svg.js";
import Hi from "./icons/brand/brand-google-gmail.svg.js";
import Oi from "./icons/brand/brand-google.svg.js";
import Wi from "./icons/brand/brand-music-itunes.svg.js";
import Ni from "./icons/brand/brand-music-soundcloud.svg.js";
import ji from "./icons/brand/brand-music-spotify.svg.js";
import Ki from "./icons/brand/brand-office-dropbox.svg.js";
import Vi from "./icons/brand/brand-office-slack.svg.js";
import Ui from "./icons/brand/brand-office-zoom.svg.js";
import zi from "./icons/brand/brand-payments-alipay.svg.js";
import Ji from "./icons/brand/brand-payments-paypal.svg.js";
import Xi from "./icons/brand/brand-payments-stripe.svg.js";
import Qi from "./icons/brand/brand-platform-android.svg.js";
import Yi from "./icons/brand/brand-platform-apple.svg.js";
import Zi from "./icons/brand/brand-platform-linux.svg.js";
import _i from "./icons/brand/brand-platform-microsoft-windows.svg.js";
import $i from "./icons/brand/brand-social-chat-discord.svg.js";
import ra from "./icons/brand/brand-social-chat-kuaishou.svg.js";
import ea from "./icons/brand/brand-social-chat-line.svg.js";
import oa from "./icons/brand/brand-social-chat-messenger.svg.js";
import ia from "./icons/brand/brand-social-chat-signal.svg.js";
import aa from "./icons/brand/brand-social-chat-snapchat.svg.js";
import na from "./icons/brand/brand-social-chat-telegram.svg.js";
import ta from "./icons/brand/brand-social-chat-wechat.svg.js";
import ma from "./icons/brand/brand-social-chat-whatsapp.svg.js";
import la from "./icons/brand/brand-social-media-deviantart.svg.js";
import da from "./icons/brand/brand-social-media-dribbble.svg.js";
import pa from "./icons/brand/brand-social-media-facebook.svg.js";
import ca from "./icons/brand/brand-social-media-instagram.svg.js";
import fa from "./icons/brand/brand-social-media-linkedin.svg.js";
import ga from "./icons/brand/brand-social-media-pinterest.svg.js";
import sa from "./icons/brand/brand-social-media-reddit.svg.js";
import ua from "./icons/brand/brand-social-media-sina-weibo.svg.js";
import ba from "./icons/brand/brand-social-media-threads.svg.js";
import ha from "./icons/brand/brand-social-media-tiktok.svg.js";
import Sa from "./icons/brand/brand-social-media-tinder.svg.js";
import Ba from "./icons/brand/brand-social-media-tumblr.svg.js";
import wa from "./icons/brand/brand-social-media-twitter.svg.js";
import La from "./icons/brand/brand-software-design-figma.svg.js";
import va from "./icons/brand/brand-software-development-authy.svg.js";
import Ca from "./icons/brand/brand-software-development-digital-ocean.svg.js";
import ka from "./icons/brand/brand-software-development-docker.svg.js";
import Ia from "./icons/brand/brand-software-development-github.svg.js";
import ya from "./icons/brand/brand-software-development-jira.svg.js";
import Pa from "./icons/brand/brand-software-development-openai.svg.js";
import Da from "./icons/brand/brand-software-development-stackexchange.svg.js";
import Ea from "./icons/brand/brand-software-development-stackoverflow.svg.js";
import Ma from "./icons/brand/brand-video-netflix.svg.js";
import Aa from "./icons/brand/brand-video-twitch.svg.js";
import xa from "./icons/brand/brand-video-vimeo.svg.js";
import Ta from "./icons/brand/brand-video-youtube.svg.js";
import Fa from "./icons/brand/programming-framework-angular.svg.js";
import qa from "./icons/brand/programming-framework-astro.svg.js";
import Ra from "./icons/brand/programming-framework-laravel.svg.js";
import Ga from "./icons/brand/programming-framework-nextdotjs.svg.js";
import Ha from "./icons/brand/programming-framework-react.svg.js";
import Oa from "./icons/brand/programming-framework-vuedotjs.svg.js";
import Wa from "./icons/brand/programming-language-c.svg.js";
import Na from "./icons/brand/programming-language-clojure.svg.js";
import ja from "./icons/brand/programming-language-csharp.svg.js";
import Ka from "./icons/brand/programming-language-css3.svg.js";
import Va from "./icons/brand/programming-language-go.svg.js";
import Ua from "./icons/brand/programming-language-html5.svg.js";
import za from "./icons/brand/programming-language-java.svg.js";
import Ja from "./icons/brand/programming-language-javascript-js.svg.js";
import Xa from "./icons/brand/programming-language-json.svg.js";
import Qa from "./icons/brand/programming-language-kotlin.svg.js";
import Ya from "./icons/brand/programming-language-node.svg.js";
import Za from "./icons/brand/programming-language-objc.svg.js";
import _a from "./icons/brand/programming-language-ocaml.svg.js";
import $a from "./icons/brand/programming-language-php.svg.js";
import rn from "./icons/brand/programming-language-powershell.svg.js";
import en from "./icons/brand/programming-language-python.svg.js";
import on from "./icons/brand/programming-language-r.svg.js";
import an from "./icons/brand/programming-language-ruby.svg.js";
import nn from "./icons/brand/programming-language-scala.svg.js";
import tn from "./icons/brand/programming-language-shell.svg.js";
import mn from "./icons/brand/programming-language-swift.svg.js";
import ln from "./icons/brand/programming-language-typescript.svg.js";
import dn from "./icons/brand/programming-tool-git.svg.js";
import pn from "./icons/brand/programming-tool-tailwindcss.svg.js";
const wc = {
  "line/arrow-chevron-down": r,
  "line/arrow-chevron-left": e,
  "line/arrow-chevron-right": o,
  "line/arrow-chevron-up": i,
  "line/arrow-down": a,
  "line/arrow-left": n,
  "line/arrow-right": t,
  "line/arrow-up": m,
  "line/basic-shape-diamond": l,
  "line/basic-shape-hexagon": d,
  "line/basic-shape-primary-circle-ellipse-round": p,
  "line/basic-shape-primary-square-rectangle": c,
  "line/basic-shape-shield": f,
  "line/computer-device-desktop-monitor": g,
  "line/computer-device-desktop": s,
  "line/computer-device-laptop": u,
  "line/computer-device-mobile-phone-android-samsung-back": b,
  "line/computer-device-mobile-phone-android-samsung": h,
  "line/computer-device-mobile-phone-iphone-x-back": S,
  "line/computer-device-mobile-phone-iphone-x": B,
  "line/computer-device-mobile-tablet-touch": w,
  "line/computer-device-mobile-tablet": L,
  "line/computer-device-network-ethernet-cat6": v,
  "line/computer-device-network-lan-www": C,
  "line/computer-device-network-wifi-connection": k,
  "line/computer-device-network-wifi-router": I,
  "line/computer-keyboard-alt": y,
  "line/computer-keyboard-command-cmd-control-ctrl": P,
  "line/computer-keyboard-option": D,
  "line/computer-keyboard-shift": E,
  "line/ecology-science-erlenmeyer-flask": M,
  "line/entertainment-control-button-circle-left-arrow-rewind": A,
  "line/entertainment-control-button-circle-pause": x,
  "line/entertainment-control-button-circle-right-arrow-fast-forward": T,
  "line/entertainment-control-button-circle-stop-square": F,
  "line/entertainment-control-button-play-circle": q,
  "line/entertainment-party-popper-confetti": R,
  "line/image-flash-lightning": G,
  "line/image-photo-frame": H,
  "line/image-picture-flower": O,
  "line/interface-add": W,
  "line/interface-alert-error-exclamation-block-square": N,
  "line/interface-alert-error-x-block-square": j,
  "line/interface-alert-exclamation-diamond": K,
  "line/interface-alert-exclamation-triangle-warning": V,
  "line/interface-alert-information-circle": U,
  "line/interface-award-crown": z,
  "line/interface-bookmark-tag": J,
  "line/interface-bookmark": X,
  "line/interface-calendar-date-one": Q,
  "line/interface-close": Y,
  "line/interface-content-book-open-pages": Z,
  "line/interface-content-book-page": _,
  "line/interface-content-file": $,
  "line/interface-content-folder": rr,
  "line/interface-copy-clipboard": er,
  "line/interface-delete-bin-trash": or,
  "line/interface-dots-horizontal": ir,
  "line/interface-dots-vertical": ar,
  "line/interface-edit-attachment": nr,
  "line/interface-edit-binocular": tr,
  "line/interface-edit-magic-wand": mr,
  "line/interface-edit-tool-eraser": lr,
  "line/interface-edit-tool-paint-brush": dr,
  "line/interface-edit-tool-paint-roller": pr,
  "line/interface-edit-tool-pen": cr,
  "line/interface-edit-tool-pencil": fr,
  "line/interface-edit-view-eye": gr,
  "line/interface-favorite-award": sr,
  "line/interface-favorite-flag": ur,
  "line/interface-favorite-heart": br,
  "line/interface-favorite-star": hr,
  "line/interface-favorite-stars-shining": Sr,
  "line/interface-favorite-stars-sparkles": Br,
  "line/interface-hierarchy-flowchart": wr,
  "line/interface-home-house": Lr,
  "line/interface-hyperlink": vr,
  "line/interface-lighting-brightness": Cr,
  "line/interface-lock-closed": kr,
  "line/interface-lock-open-unlock": Ir,
  "line/interface-login-key": yr,
  "line/interface-search": Pr,
  "line/interface-setting-cog": Dr,
  "line/interface-share-megaphone-bullhorn": Er,
  "line/interface-share-rocket": Mr,
  "line/interface-share-satellite": Ar,
  "line/interface-share-space-ship": xr,
  "line/interface-share": Tr,
  "line/interface-signal-square": Fr,
  "line/interface-text-formatting-left-open-quote": qr,
  "line/interface-text-formatting-right-close-quote": Rr,
  "line/interface-time-clock-circle": Gr,
  "line/interface-time-hour-glass": Hr,
  "line/interface-users-multiple": Or,
  "line/interface-validation-checkbox-square": Wr,
  "line/interface-weather-moon": Nr,
  "line/legal-justice-hammer-gavel": jr,
  "line/mail-chat-bubble-square": Kr,
  "line/mail-send-email-paper-airplane": Vr,
  "line/mail-send-envelope": Ur,
  "line/mail-sign-hashtag": zr,
  "line/money-cashier-receipt": Jr,
  "line/money-currency-dollar-pay": Xr,
  "line/money-graph-arrow-increase": Qr,
  "line/money-graph-bar-chart-increase": Yr,
  "line/nature-ecology-leaf": Zr,
  "line/phone-telephone": _r,
  "line/programming-bug": $r,
  "line/programming-cloud": re,
  "line/programming-computer-database-server": ee,
  "line/programming-computer-database": oe,
  "line/programming-module-four-layout": ie,
  "line/programming-module-three": ae,
  "line/programming-module": ne,
  "line/programming-script-code": te,
  "line/shopping-cart": me,
  "line/shopping-gift-present": le,
  "line/shopping-shipping-box-parcel-package": de,
  "line/tag-new-circle": pe,
  "line/travel-map-earth-globe": ce,
  "solid/arrow-chevron-down": fe,
  "solid/arrow-chevron-left": ge,
  "solid/arrow-chevron-right": se,
  "solid/arrow-chevron-up": ue,
  "solid/arrow-down": be,
  "solid/arrow-left": he,
  "solid/arrow-right": Se,
  "solid/arrow-up": Be,
  "solid/basic-shape-diamond": we,
  "solid/basic-shape-hexagon": Le,
  "solid/basic-shape-primary-circle-ellipse-round": ve,
  "solid/basic-shape-primary-square-rectangle": Ce,
  "solid/basic-shape-shield": ke,
  "solid/computer-device-desktop-monitor": Ie,
  "solid/computer-device-desktop": ye,
  "solid/computer-device-laptop": Pe,
  "solid/computer-device-mobile-phone-android-samsung-back": De,
  "solid/computer-device-mobile-phone-android-samsung": Ee,
  "solid/computer-device-mobile-phone-iphone-x-back": Me,
  "solid/computer-device-mobile-phone-iphone-x": Ae,
  "solid/computer-device-mobile-tablet-touch": xe,
  "solid/computer-device-mobile-tablet": Te,
  "solid/computer-device-network-ethernet-cat6": Fe,
  "solid/computer-device-network-lan-www": qe,
  "solid/computer-device-network-wifi-connection": Re,
  "solid/computer-device-network-wifi-router": Ge,
  "solid/computer-keyboard-alt": He,
  "solid/computer-keyboard-command-cmd-control-ctrl": Oe,
  "solid/computer-keyboard-option": We,
  "solid/computer-keyboard-shift": Ne,
  "solid/ecology-science-erlenmeyer-flask": je,
  "solid/entertainment-control-button-circle-left-arrow-rewind": Ke,
  "solid/entertainment-control-button-circle-pause": Ve,
  "solid/entertainment-control-button-circle-play": Ue,
  "solid/entertainment-control-button-circle-right-arrow-fast-forward": ze,
  "solid/entertainment-control-button-circle-stop-square": Je,
  "solid/entertainment-party-popper-confetti": Xe,
  "solid/image-flash-lightning": Qe,
  "solid/image-photo-frame": Ye,
  "solid/image-picture-flower": Ze,
  "solid/interface-add-square": _e,
  "solid/interface-alert-error-exclamation-block-square": $e,
  "solid/interface-alert-error-x-block-square": ro,
  "solid/interface-alert-exclamation-diamond": eo,
  "solid/interface-alert-exclamation-triangle-warning": oo,
  "solid/interface-alert-information-circle": io,
  "solid/interface-award-crown": ao,
  "solid/interface-bookmark-tag": no,
  "solid/interface-bookmark": to,
  "solid/interface-calendar-date-one": mo,
  "solid/interface-close": lo,
  "solid/interface-content-book-open-pages": po,
  "solid/interface-content-book-page": co,
  "solid/interface-content-file": fo,
  "solid/interface-content-folder": go,
  "solid/interface-copy-clipboard": so,
  "solid/interface-delete-bin-trash": uo,
  "solid/interface-dots-horizontal": bo,
  "solid/interface-dots-vertical": ho,
  "solid/interface-edit-attachment": So,
  "solid/interface-edit-binocular": Bo,
  "solid/interface-edit-magic-wand": wo,
  "solid/interface-edit-tool-eraser": Lo,
  "solid/interface-edit-tool-paint-brush": vo,
  "solid/interface-edit-tool-paint-roller": Co,
  "solid/interface-edit-tool-pen": ko,
  "solid/interface-edit-tool-pencil": Io,
  "solid/interface-edit-view-eye": yo,
  "solid/interface-favorite-award": Po,
  "solid/interface-favorite-flag": Do,
  "solid/interface-favorite-heart": Eo,
  "solid/interface-favorite-star": Mo,
  "solid/interface-favorite-stars-shining": Ao,
  "solid/interface-favorite-stars-sparkles": xo,
  "solid/interface-hierarchy-flowchart": To,
  "solid/interface-home-house": Fo,
  "solid/interface-hyperlink": qo,
  "solid/interface-lighting-brightness": Ro,
  "solid/interface-lock-closed": Go,
  "solid/interface-lock-open-unlock": Ho,
  "solid/interface-login-key": Oo,
  "solid/interface-search": Wo,
  "solid/interface-setting-cog": No,
  "solid/interface-share-megaphone-bullhorn": jo,
  "solid/interface-share-rocket": Ko,
  "solid/interface-share-satellite": Vo,
  "solid/interface-share-space-ship": Uo,
  "solid/interface-share": zo,
  "solid/interface-signal-square": Jo,
  "solid/interface-text-formatting-left-open-quote": Xo,
  "solid/interface-text-formatting-right-close-quote": Qo,
  "solid/interface-time-clock-circle": Yo,
  "solid/interface-time-hour-glass": Zo,
  "solid/interface-users-multiple": _o,
  "solid/interface-validation-checkbox-square": $o,
  "solid/interface-weather-moon": ri,
  "solid/legal-justice-hammer-gavel": ei,
  "solid/mail-chat-bubble-square": oi,
  "solid/mail-send-email-paper-airplane": ii,
  "solid/mail-send-envelope": ai,
  "solid/mail-sign-hashtag": ni,
  "solid/money-cashier-receipt": ti,
  "solid/money-currency-dollar-pay": mi,
  "solid/money-graph-arrow-increase": li,
  "solid/money-graph-bar-chart-increase": di,
  "solid/nature-ecology-leaf": pi,
  "solid/phone-telephone": ci,
  "solid/programming-bug": fi,
  "solid/programming-cloud": gi,
  "solid/programming-computer-database-server": si,
  "solid/programming-computer-database": ui,
  "solid/programming-module-four-layout": bi,
  "solid/programming-module-three": hi,
  "solid/programming-module": Si,
  "solid/programming-script-code": Bi,
  "solid/shopping-cart": wi,
  "solid/shopping-gift-present": Li,
  "solid/shopping-shipping-box-parcel-package": vi,
  "solid/tag-new-circle": Ci,
  "solid/travel-map-earth-globe": ki,
  "brand/brand-adobe": Ii,
  "brand/brand-amazon": yi,
  "brand/brand-browser-firefox": Pi,
  "brand/brand-browser-googlechrome": Di,
  "brand/brand-creative-commons": Ei,
  "brand/brand-ecommerce-etsy": Mi,
  "brand/brand-ecommerce-patreon": Ai,
  "brand/brand-ecommerce-shopify": xi,
  "brand/brand-ecommerce-wordpress": Ti,
  "brand/brand-gaming-nintendo-switch": Fi,
  "brand/brand-gaming-playstation": qi,
  "brand/brand-gaming-xbox-live": Ri,
  "brand/brand-google-drive": Gi,
  "brand/brand-google-gmail": Hi,
  "brand/brand-google": Oi,
  "brand/brand-music-itunes": Wi,
  "brand/brand-music-soundcloud": Ni,
  "brand/brand-music-spotify": ji,
  "brand/brand-office-dropbox": Ki,
  "brand/brand-office-slack": Vi,
  "brand/brand-office-zoom": Ui,
  "brand/brand-payments-alipay": zi,
  "brand/brand-payments-paypal": Ji,
  "brand/brand-payments-stripe": Xi,
  "brand/brand-platform-android": Qi,
  "brand/brand-platform-apple": Yi,
  "brand/brand-platform-linux": Zi,
  "brand/brand-platform-microsoft-windows": _i,
  "brand/brand-social-chat-discord": $i,
  "brand/brand-social-chat-kuaishou": ra,
  "brand/brand-social-chat-line": ea,
  "brand/brand-social-chat-messenger": oa,
  "brand/brand-social-chat-signal": ia,
  "brand/brand-social-chat-snapchat": aa,
  "brand/brand-social-chat-telegram": na,
  "brand/brand-social-chat-wechat": ta,
  "brand/brand-social-chat-whatsapp": ma,
  "brand/brand-social-media-deviantart": la,
  "brand/brand-social-media-dribbble": da,
  "brand/brand-social-media-facebook": pa,
  "brand/brand-social-media-instagram": ca,
  "brand/brand-social-media-linkedin": fa,
  "brand/brand-social-media-pinterest": ga,
  "brand/brand-social-media-reddit": sa,
  "brand/brand-social-media-sina-weibo": ua,
  "brand/brand-social-media-threads": ba,
  "brand/brand-social-media-tiktok": ha,
  "brand/brand-social-media-tinder": Sa,
  "brand/brand-social-media-tumblr": Ba,
  "brand/brand-social-media-twitter": wa,
  "brand/brand-software-design-figma": La,
  "brand/brand-software-development-authy": va,
  "brand/brand-software-development-digital-ocean": Ca,
  "brand/brand-software-development-docker": ka,
  "brand/brand-software-development-github": Ia,
  "brand/brand-software-development-jira": ya,
  "brand/brand-software-development-openai": Pa,
  "brand/brand-software-development-stackexchange": Da,
  "brand/brand-software-development-stackoverflow": Ea,
  "brand/brand-video-netflix": Ma,
  "brand/brand-video-twitch": Aa,
  "brand/brand-video-vimeo": xa,
  "brand/brand-video-youtube": Ta,
  "brand/programming-framework-angular": Fa,
  "brand/programming-framework-astro": qa,
  "brand/programming-framework-laravel": Ra,
  "brand/programming-framework-nextdotjs": Ga,
  "brand/programming-framework-react": Ha,
  "brand/programming-framework-vuedotjs": Oa,
  "brand/programming-language-c": Wa,
  "brand/programming-language-clojure": Na,
  "brand/programming-language-csharp": ja,
  "brand/programming-language-css3": Ka,
  "brand/programming-language-go": Va,
  "brand/programming-language-html5": Ua,
  "brand/programming-language-java": za,
  "brand/programming-language-javascript-js": Ja,
  "brand/programming-language-json": Xa,
  "brand/programming-language-kotlin": Qa,
  "brand/programming-language-node": Ya,
  "brand/programming-language-objc": Za,
  "brand/programming-language-ocaml": _a,
  "brand/programming-language-php": $a,
  "brand/programming-language-powershell": rn,
  "brand/programming-language-python": en,
  "brand/programming-language-r": on,
  "brand/programming-language-ruby": an,
  "brand/programming-language-scala": nn,
  "brand/programming-language-shell": tn,
  "brand/programming-language-swift": mn,
  "brand/programming-language-typescript": ln,
  "brand/programming-tool-git": dn,
  "brand/programming-tool-tailwindcss": pn
};
export {
  wc as rawIcons
};
